import {
    ExpenseSubMode,
    ScheduleSourceType,
    ScheduleType,
} from "@common/types/domains/accounting/schedule";

export type ScheduleDocumentType =
    | ScheduleSourceType.invoice
    | ScheduleSourceType.bill;

/** Invoices take revenue policies; bills take expense ones. */
export function canScheduleDocument(options: {
    template: { type: ScheduleType; expenseSubMode?: ExpenseSubMode | null };
    documentType: ScheduleDocumentType;
}): boolean {
    const { template, documentType } = options;
    switch (template.type) {
        case ScheduleType.revenue:
            return documentType === ScheduleSourceType.invoice;
        case ScheduleType.expense:
            return (
                documentType === ScheduleSourceType.bill &&
                (template.expenseSubMode ?? null) !== null
            );
        case ScheduleType.fixedAsset:
            return false;
    }
}
